












import FormValues from '@/types/form-values'
import Vue from 'vue'
import Contact from '@/containers/contact.vue'
import Confirm from '@/containers/confirm.vue'

export default Vue.extend({
  components: { Contact, Confirm },
  data() {
    return {
      isConfirm: false,
      values: {
        name: '',
        nameKana: '',
        email: '',
        phoneNumber: '',
        content: '',
        prefecture: '',
        birthday: {
          year: '',
          month: '',
          day: ''
        },
        gender: '',
        work: '',
        whereIt: '',
        whereItOther: ''
      }
    }
  },
  watch: {
    values(args) {
      console.log(args)
    }
  },
  methods: {
    setFormValues(values: FormValues) {
      this.values = values
      this.isConfirm = true
    },
    leaveConfirm(bool: boolean) {
      this.isConfirm = bool
    }
  }
})
